import { ReportSection, ReportMetadata } from "~/types/global";
import { StateCreator } from "zustand";
import { ReportDetailState } from "../interface";

export interface DataActions {
  setReportSections: (sections: ReportSection[]) => void;
  setDeletedSections: (sections: ReportSection[]) => void;
  setReportType: (type: string) => void;
  setMetadata: (metadata: ReportMetadata) => void;
  setProfileImage: (image: string) => void;
  setSelectedCombinedFilter: (filterId: string) => void;
  setCombinedReportSources: (sources: Array<{
    report_type: string;
    report_input_value: string | Record<string, any>;
    user_reports_id: string;
    report_name: string;
  }>) => void;
}

export const createDataActions: StateCreator<
  ReportDetailState & { actions: any },
  [],
  [],
  DataActions
> = (set) => ({
  setReportSections: (sections) =>
    set((state) => ({
      data: { ...state.data, sections },
    })),

  setDeletedSections: (deletedSections) =>
    set((state) => ({
      data: { ...state.data, deletedSections },
    })),

  setReportType: (reportType) =>
    set((state) => ({
      data: { ...state.data, reportType },
    })),

  setMetadata: (metadata) =>
    set((state) => ({
      data: { ...state.data, metadata },
    })),

  setProfileImage: (profileImage) =>
    set((state) => ({
      data: { ...state.data, profileImage },
    })),

  setSelectedCombinedFilter: (selectedCombinedFilter) =>
    set((state) => ({
      data: { ...state.data, selectedCombinedFilter },
    })),

  setCombinedReportSources: (combinedReportSources) =>
    set((state) => ({
      data: { ...state.data, combinedReportSources },
    })),
});
